import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import * as React from "react";

import { cn } from "../../lib/utils";

const ScrollArea = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & {
		viewPortProps?: React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Viewport> & {
			ref?: React.RefObject<HTMLDivElement | null>;
		};
	}
>(({ className, children, viewPortProps, ...props }, ref) => (
	<ScrollAreaPrimitive.Root
		ref={ref}
		className={cn(
			// Class list here is to resolve nested display: table issue
			// https://github.com/radix-ui/primitives/issues/2722
			"relative overflow-hidden",
			"[&>div>div:not([data-scroll-area-scrollbar])]:!flex",
			"[&>div>div:not([data-scroll-area-scrollbar])]:!flex-col",
			"[&>div>div:not([data-scroll-area-scrollbar])]:!h-full",
			"[&>div>div:not([data-scroll-area-scrollbar])]:!min-h-0",
			className,
		)}
		type="always"
		{...props}
	>
		<ScrollAreaPrimitive.Viewport
			{...viewPortProps}
			className={cn("h-full w-full rounded-[inherit]", viewPortProps?.className)}
		>
			{children}
		</ScrollAreaPrimitive.Viewport>
		<ScrollBar />
		<ScrollAreaPrimitive.Corner />
	</ScrollAreaPrimitive.Root>
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
	React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({ className, orientation = "vertical", ...props }, ref) => (
	<ScrollAreaPrimitive.ScrollAreaScrollbar
		ref={ref}
		orientation={orientation}
		className={cn(
			"flex touch-none select-none transition-colors",
			orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
			orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
			className,
		)}
		{...props}
	>
		<ScrollAreaPrimitive.ScrollAreaThumb
			className="relative flex-1 rounded-full bg-border"
			data-scroll-area-scrollbar
		/>
	</ScrollAreaPrimitive.ScrollAreaScrollbar>
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
